import { B64File } from 'common/classes/B64File.class';
import { deleteAvatarAsync, saveAvatarAsync } from 'membre/store/actions';
import { dispatch } from 'store/store';
/**
 * Permet aux utilisateur d'avoir plusieurs photos de profil
 */
export class MembreImageProfil {
    /**
     * Constructeur de l'objet MembreImageProfil
     * @param row array contenant les données de l'objet
     */
    constructor(row) {
        var _a, _b, _c, _d;
        if (row) {
            this.idMembreImageProfil = (_a = row.idMembreImageProfil) !== null && _a !== void 0 ? _a : null;
            this.idMembre = (_b = row.idMembre) !== null && _b !== void 0 ? _b : null;
            this.dateEnregistrement = (_c = row.dateEnregistrement) !== null && _c !== void 0 ? _c : null;
            this.actif = (_d = row.actif) !== null && _d !== void 0 ? _d : 0;
            this.profilePicture = row.profilePicture ? new B64File(row.profilePicture) : null;
        }
    }
    /**
     * Sauvegarde une nouvelle image de profil
     * @return True si l'image de profil a été enregistrée avec succès, false sinon
     */
    save() {
        dispatch(saveAvatarAsync(this));
    }
    /**
     * Supprime l'image de profil
     * @return True si l'image de profil a été supprimée avec succès, false sinon
     */
    delete() {
        dispatch(deleteAvatarAsync(this));
    }
    /**
     * Utilisée pour renvoyer les informations au back.
     */
    toRaw() {
        var _a, _b;
        return {
            idMembreImageProfil: this.idMembreImageProfil,
            idMembre: this.idMembre,
            dateEnregistrement: this.dateEnregistrement,
            actif: this.actif,
            profilePicture: (_b = (_a = this.profilePicture) === null || _a === void 0 ? void 0 : _a.toRaw()) !== null && _b !== void 0 ? _b : null,
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVtYnJlSW1hZ2VQcm9maWwuY2xhc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJNZW1icmVJbWFnZVByb2ZpbC5jbGFzcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFDdkQsT0FBTyxFQUFFLGlCQUFpQixFQUFFLGVBQWUsRUFBRSxNQUFNLHNCQUFzQixDQUFDO0FBQzFFLE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFJdkM7O0dBRUc7QUFDSCxNQUFNLE9BQU8saUJBQWlCO0lBK0I3Qjs7O09BR0c7SUFDSCxZQUFtQixHQUFnQzs7UUFDbEQsSUFBSSxHQUFHLEVBQUU7WUFDUixJQUFJLENBQUMsbUJBQW1CLEdBQUcsTUFBQSxHQUFHLENBQUMsbUJBQW1CLG1DQUFJLElBQUksQ0FBQztZQUMzRCxJQUFJLENBQUMsUUFBUSxHQUFHLE1BQUEsR0FBRyxDQUFDLFFBQVEsbUNBQUksSUFBSSxDQUFDO1lBQ3JDLElBQUksQ0FBQyxrQkFBa0IsR0FBRyxNQUFBLEdBQUcsQ0FBQyxrQkFBa0IsbUNBQUksSUFBSSxDQUFDO1lBQ3pELElBQUksQ0FBQyxLQUFLLEdBQUcsTUFBQSxHQUFHLENBQUMsS0FBSyxtQ0FBSSxDQUFDLENBQUM7WUFDNUIsSUFBSSxDQUFDLGNBQWMsR0FBRyxHQUFHLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxJQUFJLE9BQU8sQ0FBQyxHQUFHLENBQUMsY0FBYyxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztTQUNsRjtJQUNGLENBQUM7SUFFRDs7O09BR0c7SUFDSSxJQUFJO1FBQ1YsUUFBUSxDQUFDLGVBQWUsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO0lBQ2pDLENBQUM7SUFFRDs7O09BR0c7SUFDSSxNQUFNO1FBQ1osUUFBUSxDQUFDLGlCQUFpQixDQUFDLElBQUksQ0FBQyxDQUFDLENBQUM7SUFDbkMsQ0FBQztJQUVEOztPQUVHO0lBQ0ksS0FBSzs7UUFDWCxPQUFPO1lBQ04sbUJBQW1CLEVBQUUsSUFBSSxDQUFDLG1CQUFtQjtZQUM3QyxRQUFRLEVBQUUsSUFBSSxDQUFDLFFBQVE7WUFDdkIsa0JBQWtCLEVBQUUsSUFBSSxDQUFDLGtCQUFrQjtZQUMzQyxLQUFLLEVBQUUsSUFBSSxDQUFDLEtBQUs7WUFDakIsY0FBYyxFQUFFLE1BQUEsTUFBQSxJQUFJLENBQUMsY0FBYywwQ0FBRSxLQUFLLEVBQUUsbUNBQUksSUFBSTtTQUNwRCxDQUFDO0lBQ0gsQ0FBQztDQUNEIn0=